// extracted by mini-css-extract-plugin
export var container = "_c4-0";
export var content = "_c4-3";
export var customerTitle = "_c4-4";
export var empty = "_c4-5";
export var gray = "_c4-6";
export var header = "_c4-7";
export var info = "_c4-8";
export var loading = "_c4-2";
export var loadingCard = "_c4-9";
export var oneLine = "_c4-a";
export var personName = "_c4-e";
export var pillContainer = "_c4-b";
export var selected = "_c4-1";
export var text = "_c4-c";
export var twoLines = "_c4-d";
export var unread = "_c4-f";
export var unreadIndicator = "_c4-g";